
<div class="card">
  <div class="card-header px-3 py-2" id="headingRepCodes">
    <div class="card-header-title">
      <button class="btn btn-block text-left" type="button"
        data-toggle="collapse" data-target="#collapseRepCodes"
        aria-expanded="false" aria-controls="collapseRepCodes">
        <span class="font-weight-bold">RepCodes</span>
        <i class="fa fa-chevron-up ml-1"></i>
      </button>
    </div>
    <button
      type="button"
      class="btn btn-sm btn-outline-secondary add-repcode"
      title="Add RepCode"
      v-on:click.stop="click(`add`)">
      <i class="fas fa-plus-square mr-2"></i>
      <span>Add</span>
    </button>
  </div>
  <div id="collapseRepCodes" class="collapse" aria-labelledby="headingRepCodes" data-parent="#accordionMenu">
    <div class="card-body pt-3">
      <search :o="table"></search>
      <div class="d-flex align-items-center py-2 select-all-bar">
        <input
          type="checkbox"
          class="repcode-checkbox mr-2"
          :checked="allSelected"
          :title="allSelected ? `Deselect all visible repcodes` : `Select all visible repcodes`"
          v-on:click.stop="selectAll($event.target.checked)"
        />
        <span class="text-muted" v-text="`Select All (${table.items.length})`"></span>
        <a
          v-if="selectedCount > 0"
          href="#"
          class="text-muted ml-auto p-0"
          style="font-size: 0.75rem; text-decoration: none;"
          title="Deselect all repcodes"
          v-on:click.stop="deselectAll()"
        >
          Deselect All ({{ selectedCount }})
        </a>
      </div>
      <div class="repcodes">
        <scroll-area class="pr-3">
          <table class="table table-sm">
            <tbody>
              <tr v-for="(o, i) in table.items" :key="i" class="repcode">
                <td>
                  <input
                    type="checkbox"
                    class="repcode-checkbox mr-1"
                    :checked="isSelected(o)"
                    v-on:click.stop="toggle(o)"
                  />
                  <i
                    v-if="o.code !== null"
                    class="far fa-edit mr-1"
                    :title="title(`edit`)"
                    v-on:click="click(`edit`, o)"
                  ></i>
                  <a
                    href="#"
                    class="badge badge-light"
                    :title="getBillingTitle(o)"
                    v-on:click="click(`view`, o)"
                    v-text="o.label"
                  ></a>
                  <small class="text-muted ml-2"
                    v-text="`(${o.contractCount}/${o.invoiceCount}/${o.accountCount})`"
                    title="Contracts / Invoices / Accounts"
                  ></small>
                </td>
              </tr>
            </tbody>
          </table>
        </scroll-area>
      </div>
    </div>
  </div>
</div>
